"use strict";

var kontonummer = require('./lib/kontonummer');

module.exports = kontonummer;